<template>
  <div class="container">
    <div class="card">
      <router-link :to="{ name: 'game-login' }">
        <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      </router-link>
      <div class="block">
        <h2 v-text="'Mot de passe oublié ?'" />
        <p>Saisissez votre nouveau mot de passe ci-dessous</p>
      </div>
      <VForm
        :button="{
          label: 'Réinitialiser votre mot de passe',
          class: 'primary full-size',
          hotDisabled: true,
        }"
        :callback="submit"
      >
        <template #form-body="{ errors }">
          <VField
            type="password"
            placeholder="••••••••••••"
            name="password"
            v-model="state.password"
            rules="required|password"
            label="Nouveau mot de passe"
            :helper="$t('form.register.must8char')"
            :class="{ invalid: Object.keys(errors)[0] === 'password' }"
          />
          <VField
            type="password"
            placeholder="••••••••••••"
            name="confirmPassword"
            v-model="state.confirmPassword"
            rules="required|match:@password"
            label="Confirmer le nouveau mot de passe"
            :class="{ invalid: Object.keys(errors)[0] === 'confirmPassword' }"
          />
        </template>
      </VForm>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive } from "vue";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { useCandidateStore } from "@/stores/candidate.js";
import { setToken } from "@/composables/token.js";
import { getError } from "@/composables/error.js";

const toast = useToast();

const router = useRouter();
const route = useRoute();

const candidateStore = useCandidateStore();
const { auth_token_game, candidate } = storeToRefs(candidateStore);

const state = reactive({
  password: "",
  confirmPassword: "",
  error: null,
});

if (!route.query.reset_id) {
  router.push({ name: "game-login" });
}

async function submit() {
  const resp = await candidateStore.resetPassword(
    route.query.reset_id,
    state.password
  );

  if (resp.token) {
    setToken(resp.token, "auth_token_game", auth_token_game);

    candidate.value = resp.candidate;

    router.push({ name: "game-home" });

    toast.success("Votre mot de passe a bien été modifié.");
  } else {
    state.password = "";
    state.confirmPassword = "";
    toast.error(getError(resp.key));
  }
}
</script>
